// 韩语(Korean)
export default {
  oneOneClass: "",
  learnPracEnFast: "",
  htOralClass: "",
  benefits: "",
  topicNumber: "",
  dailyBusinessAcademic: "",
  englishTutors: "",
  qualifiedTutors: "",
  nativeOkAllAges: "",
  oneOneLive: "",
  accessToRecord: "",
  personalizedPlan: "",
  ensureGoal: "",
  professional: "",
  nativeTeam: "",
  authenticLanguage: "",
  bgChecked: "",
  experiencedTeachers: "",
  assuredQuality: "",
  regularAssess: "",
  assuredSatisfaction: "",
  teamSizeAndRefund: "",
  curriculum: "",
  dailyTalks: "",
  beginnerInfo: "",
  lessonOverview: "",
  beginnerClassIntro: "",
  topicEx: "",
  beginnerTopicEx: "",
  mediateInfo: "",
  mediateClassIntro: "",
  mediateTopicEx: "",
  advancedInfo: "",
  advancedClassIntro: "",
  advancedTopicEx: "",
  businessLanguage: "",
  busElementInfo: "",
  busElementClassIntro: "",
  busElementTopicEx: "",
  busMediateInfo: "",
  busMediateClassIntro: "",
  busMediateTopicEx: "",
  ielts: "",
  languageTests: "",
  aHundredLessons: "",
  ieltsClassIntro: "",
  faq: "",
  questionCn: "",
  classLength: "",
  classInfoAndSuggest: "",
  lessonForm: "",
  lessonFormInfo: "",
  lessonPrepare: "",
  lessonPrepareInfo: "",
  support: "",
  limitedOffer: "",
  originalPrice: "",
  bookNow: "",
  successPurchase: "",
  trialEndAndGoOn: "",
  courseAdvisor: "",
  oneLastStep: "",
  ticketPrice: "",
  perPriceAndOrder: "",
  noThanks: "",
  unpaidAndProceed: "",
  halfPrice: "",
  languageEn: "",
  languageKo: "",
  languageEsp: "",
  languageFr: "",
  languageIt: "",
  languageRu: "",
  languageCn: "",
  languageJp: "",
  courseEn: "",
  courseKo: "",
  courseEsp: "",
  courseFr: "",
  courseIt: "",
  courseRu: "",
  courseCn: "",
  courseJp: "",
  enTestEn: "IELTS",
  koTestEn: "TOPIK",
  espTestEn: "DELE",
  frTestEn: "DELF/DEAL/TE",
  itTestEn: "CILS",
  ruTestEn: "ТРКИ",
  jpTestEn: "JLPT",
  cnTestEn: "HSK",
  coinSpecialOffer: "HT 코인 충전 특별 제공",
  buySomeAndGetExtra: "HT 코인을 구입하고 추가금도 받으세요!",
  balance: "잔고",
  coins: "{number} 코인",
  coin: "{number} 코인",
  extraCoins: "{number} 추가 코인",
  continue: "계속하기",
  byToppingUpYouAgree: "구매는 충전 계약에 동의함을 의미합니다",
  topUpAgreement: "[충전 동의]",
  htCoin: "HT 코인",
  scanCodeToLog: "로그인하려면 코드를 스캔하세요",
  bindYourHelloTalkAccount:
    "헬로톡 앱을 사용하여 코드를 스캔하고 로그인합니다. 헬로톡 계정을 연동하고 충전합니다.",
  itemSelection: "아이템 선택",
  paymentAmount: "양",
  topUpSuccessful: "충전 성공👏",
  totalCoinsNumber:
    "당신은 {numberone} 코인을 성공적으로 추가하셨고 {numbertwo} 추가 코인을 받아 총 {numberall} 코인을 얻었습니다.",
  ok: "OK",
  copyLinkToPay:
    "링크를 복사하시고 헬로톡 앱으로 링크를 열어 결제를 완료해주세요.",
  paymentFailed: "결제가 실패하였습니다",
  creditCardPay: "PayPal 또는 신용카드로 결제",
  creditCard: "신용카드",
};
